export const payloadTypes = {
  choicePrompt: 'choice_prompt',
  text: 'text',
  image: 'image',
  video: 'video',
  participant: 'participant',
  divider: 'divider',
  translation: 'translation',
  message: 'message',
  countdown: 'countdown',
  upload: 'upload',
}
const defaultTranslatedBody = {
  direction: 'to_translation_locale',
  locale: 'nl',
  translatedBy: 'deep_l',
  data: {},
}

export function addTranslationData(event) {
  switch (event.payload.type) {
    case payloadTypes.image:
    case payloadTypes.text:
    case payloadTypes.choicePrompt:
      return {
        ...event,
        payload: {
          ...event.payload,
          translatedBody: {
            ...defaultTranslatedBody,
            data: {
              ...event.payload.body,
              text: event.payload.body.text
                ? `NL - ${event.payload.body.text}`
                : undefined,
              description: event.payload.body.description
                ? `NL - ${event.payload.body.description}`
                : undefined,
              buttonText: event.payload.body.buttonText
                ? `NL - ${event.payload.body.buttonText}`
                : undefined,
              choices: event.payload.body.choices
                ? event.payload.body.choices.map((choice) => ({
                    ...choice,
                    text: `NL - ${choice.text}`,
                  }))
                : undefined,
              prompt: event.payload.body.prompt
                ? {
                    ...event.payload.body.prompt,
                    text: `NL - ${event.payload.body.prompt.text}`,
                  }
                : undefined,
            },
          },
        },
      }
    default:
      return event
  }
}
